import { PropsWithChildren, SVGProps } from 'react';
import { Disclosure } from '@headlessui/react';
import cns from 'classnames';
import { cn } from '@zep/utils';
import S from './Accordion.module.scss';
const ChevronIcon = (props: SVGProps<SVGSVGElement>) => <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg" {...props} data-sentry-element="svg" data-sentry-component="ChevronIcon" data-sentry-source-file="Accordion.tsx">
    <path d="M11.293 7.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L12 9.414l-5.293 5.293a1 1 0 0 1-1.414-1.414l6-6Z" fill="currentColor" data-sentry-element="path" data-sentry-source-file="Accordion.tsx" />
  </svg>;
export const AccordionText = ({
  type = 'info',
  children
}: PropsWithChildren<{
  type?: 'info' | 'danger' | 'success';
}>) => {
  return <span className={cns(S.text, {
    [S[`${type}`]]: type
  })} data-sentry-component="AccordionText" data-sentry-source-file="Accordion.tsx">{children}</span>;
};
export const AccordionButton = ({
  children,
  onClick,
  className
}: AccordionButtonProps) => {
  return <Disclosure.Button className={S.button} data-sentry-element="unknown" data-sentry-component="AccordionButton" data-sentry-source-file="Accordion.tsx">
      <div className={cn(S.button_field, className)} onClick={onClick}>
        {children}
        <ChevronIcon className={S.icon} aria-hidden="true" data-sentry-element="ChevronIcon" data-sentry-source-file="Accordion.tsx" />
      </div>
    </Disclosure.Button>;
};
export const AccordionPanel = ({
  className,
  children
}: PropsWithChildren<{
  className?: string;
}>) => {
  return <Disclosure.Panel className={cn(S.panel, className)} data-sentry-element="unknown" data-sentry-component="AccordionPanel" data-sentry-source-file="Accordion.tsx">
      {children}
    </Disclosure.Panel>;
};
export const Accordion = ({
  isOpen,
  className,
  children
}: PropsWithChildren<{
  isOpen?: boolean;
  className?: string;
}>) => {
  return <Disclosure defaultOpen={isOpen} data-sentry-element="Disclosure" data-sentry-component="Accordion" data-sentry-source-file="Accordion.tsx">
      {({
      open
    }) => <div className={cn(S.accordion, {
      [S.open]: open
    }, className)}>
          {children}
        </div>}
    </Disclosure>;
};
type AccordionButtonProps = PropsWithChildren<{
  className?: string;
}> & {
  onClick?: () => void;
};